import React, { useRef } from 'react';
import { Icon } from '@fiverr-private/fit';
import { useEnteredView } from '@fiverr-private/hooks';
import { I18n } from '@fiverr-private/i18n-react';
import { StarBubbleIcon } from '@fiverr-private/icons';
import { Container, Stack } from '@fiverr-private/layout_components';
import { FederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { theme } from '@fiverr-private/theme';
import { Tooltip } from '@fiverr-private/tooltip';
import { Text } from '@fiverr-private/typography';
import { useBI } from '../../BIContext';
import { TabName, scrollToTab } from '../../StickyHeader/tab-names';
import { iconClass } from './Recommendations.ve.css';

interface Props {
    sellerRoleId?: string;
}

export const Recommendations = ({ sellerRoleId }: Props) => {
    const observableRef = useRef<HTMLDivElement>(null);
    const { testimonials } = useSellerData(selectSellerSlice);
    const { reportSellerHighlightsRecommendationsClicked, reportSellerHighlightsRecommendationsImpression } = useBI();

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () => {
            reportSellerHighlightsRecommendationsImpression({
                label: testimonials.length.toString(),
            });
        },
    });

    const handleClick = () => {
        scrollToTab({
            tabId: TabName.Testimonials,
            roleId: sellerRoleId,
        });
        reportSellerHighlightsRecommendationsClicked({
            label: testimonials.length.toString(),
        });
    };

    return (
        <Container ref={observableRef}>
            <Tooltip content={<I18n k="seller_page_perseus.professions_page.highlights.recommendations_tooltip" />}>
                <Stack alignItems="center" gap="2" marginBottom="1">
                    <Icon className={iconClass}>
                        <StarBubbleIcon color={theme.colors.grey_1200} />
                    </Icon>
                    <Text
                        size={{
                            default: 'b_lg',
                            md: 'b_xl',
                            lg: 'b_xxl',
                        }}
                        fontWeight="bold"
                    >
                        {testimonials.length}
                    </Text>
                </Stack>
            </Tooltip>
            <Text
                size="b_sm"
                fontWeight="semibold"
                decoration="underline"
                cursor="pointer"
                marginTop="1"
                onClick={handleClick}
            >
                <I18n k="seller_page_perseus.professions_page.highlights.recommendations" />
            </Text>
        </Container>
    );
};

const selectSellerSlice = (seller: FederatedSeller) => ({
    testimonials: seller.testimonials,
});
